import constants from '@/utils/constants';

export default {
  methods: {
    dimensions(data) {
      return `${data.length} x ${data.width} x ${data.height}`;
    },
    yesNoLabel(value) {
      return value ? constants.STATUS_BOOLEAN.yes.label : constants.STATUS_BOOLEAN.no.label;
    },
    damagedLabel(damage) {
      return damage ? constants.STATUS_BOOLEAN.yes.label : constants.STATUS_BOOLEAN.no.label;
    },
    statusLabel(status, hasShuttle) {
      const statusReceived = constants.UNIT.STATUS[2];
      const statusArrived = constants.UNIT.STATUS[8];
      const statusFind = constants.UNIT.STATUS.find(element => element.value === status);

      if (statusFind) {
        return (statusFind === statusReceived && hasShuttle) ? statusArrived.label : statusFind.label;
      }
      return null;
    },
    palletStatusLabel(palletStatus) {
      return palletStatus != null ? this.$t(constants.UNIT.PALLET_STATUS[palletStatus].label) : null;
    },
    loadsLabel(status) {
      const statusFind = constants.LOADS.STATUS.find(element => element.value === status);
      return statusFind ? statusFind.label : null;
    },
    shuttleLoadsLabel(status) {
      const statusFind = constants.SHUTTLE_LOADS.STATUS.find(element => element.value === status);
      return statusFind ? statusFind.label : null;
    },
    finalizedLabel(finalized) {
      return finalized ? constants.STATUS_BOOLEAN.yes.label : constants.STATUS_BOOLEAN.no.label;
    },
    ratedLabel(rated) {
      return rated ? constants.STATUS_BOOLEAN.yes.label : constants.STATUS_BOOLEAN.no.label;
    },
    shipmentStatusLabel(status) {
      return status ? this.$t(constants.SHIPMENT.STATUS[status].label) : null;
    },
    coolerInventoryStatusLabel(status) {
      const statusFind = constants.COOLER_INVENTORY.STATUS.find(element => element.value === status);
      return statusFind ? statusFind.label : null;
    },
    palletReceiptStatusLabel(status) {
      const statusFind = constants.PALLET_RECEIPT.STATUS.find(element => element.value === status);
      return statusFind ? statusFind.label : null;
    },
    unitOfMeasureLabel(unitOfMeasure) {
      const unitOfMeasureFind = constants.UNIT_OF_MEASURE_LIST_BY_ID.find(element => element.value === unitOfMeasure);
      return unitOfMeasureFind ? unitOfMeasureFind.label : null;
    }
  }
};
